export const PLATFORMS_LIST = "PLATFORMS_LIST";
